import { Dispatch } from "react";
import { AppState } from "./configureStore";
import { createSlice, PayloadAction, AnyAction } from '@reduxjs/toolkit';
import { push } from "connected-react-router";
import { client,Path } from "../App";
import { IDCRState } from './DCRStore';
import { XspUrl,XspUrlResponse } from "../DCR.dtos";
import { IEnumLoadableState, DataLoadState } from "../definitions/IEnumLoadableState";


export enum Permissions {
    ContributionDetails_Add = "ContributionDetails.Add",
    ContributionDetails_Cancel = "ContributionDetails.Cancel",
    ContributionDetails_Edit = "ContributionDetails.Edit",
    ContributionDetails_Schedule = "ContributionDetails.Schedule",
    ContributionHistory_CancelEbill = "ContributionHistory.CancelEbill",
    ContributionHistory_CancelUpload = "ContributionHistory.CancelUpload",
    ContributionHistory_Upload = "ContributionHistory.Upload",
    UpdateContributions_Submit = "UpdateContributions.Submit",
    UpdatePayment_Submit = "UpdatePayment.Submit"
}

export interface IHelperState extends IEnumLoadableState {
    xspURLReponseInfo: XspUrlResponse;
}

const initialHelperState: IHelperState = {
    xspURLReponseInfo: {} as XspUrlResponse,
    loadState: DataLoadState.None
}

const slice = createSlice({
    name: "helper",
    initialState: initialHelperState,
    reducers: {
        resetState: () => {
            return {
                ...initialHelperState
            }
        },        
        requestXSPUrl: (state: IHelperState) => {
            return {
                ...state,
                loadState: DataLoadState.Loading
            }
        },
        receiveXSPUrl: (state: IHelperState, action: PayloadAction<{
            xspURLReponseInfo: XspUrlResponse;
        }>) => {
            const xspURLReponseInfo = action.payload.xspURLReponseInfo;
            return {
                ...state,
                xspURLReponseInfo,
                loadState: DataLoadState.Loaded
            }
        }        
    }
})

const {   
    requestXSPUrl,
    receiveXSPUrl
} = slice.actions;

function fetchAllConfiguration() {
    return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
        const currentState = getState().dcr;
        if (currentState.isLoading || currentState.isLoaded) {
            return;
        }

        dispatch(requestXSPUrl());

        const xspURLReponseInfo = await client.post(new XspUrl());

        dispatch(receiveXSPUrl({ xspURLReponseInfo }));

    }
}

function goToContributionHistory() {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(push(Path.ContributionHistory));
    }
}


function goToContributionDetails() {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(push(Path.ContributionDetails));
    }
}


function goToManageAccounts() {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(push(Path.ManageAccounts));
    }
}

function isSessionAvailable(dcrState: IDCRState) {
    return dcrState.authenticated
}

export const helperReducer = slice.reducer;

export const helperActionCreators = {
    goToContributionHistory,
    goToContributionDetails,
    goToManageAccounts,
    isSessionAvailable,
    fetchAllConfiguration
}
